import loadable from '@loadable/component';
import storeCountry from 'GlobalStores/Cores/County/StoreCountry';
import DefaultReferralBar from './DefaultReferralBar';

const LoadReferralBar = loadable(
    () => import(`../../Pages/Referral/${storeCountry.CountryCapitalize()}/Components/ReferralBar/ReferralBar`)
        .catch((e) => {
            console.log('Error loading DynamicReferralBar:', e);
            return import(`./DefaultReferralBar`)

        })
)

const DynamicReferralBar = () => {
    return <LoadReferralBar />
}



export default DynamicReferralBar
